<template>
  <div class="octobus__modal" :class="{ 'is-active' : show }">
    <div class="octobus__modal-background"></div>
    <div class="octobus__modal-card">
      <header class="octobus__modal-card-head">
        <p class="octobus__modal-card-title">{{ $t('tickets.refund.title') }}</p>
        <button class="octobus__delete" aria-label="close" @click="onHideModal"></button>
      </header>
      <section class="octobus__modal-card-body">
        <p class="octobus__refund-error has-text-danger has-text-centered" v-if="error.name">{{error.name}}</p>
        <p class="octobus__refund-error" v-else>&nbsp;</p>
        <div class="octobus__columns">
          <div class="octobus__column">
            <p>1. {{ $t('tickets.refund.reason') }}</p>
          </div>
        </div>
        <div class="octobus__columns">
          <div class="octobus__column">
            <div class="octobus__field is-horizontal">
              <div class="octobus__field-body">
                <div class="octobus__field is-expanded">
                  <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="refund__reason">
                    {{ $t('tickets.refund.reasonSelect') }}
                  </label>
                  <div class="octobus__field has-addons">
                    <p class="octobus__control">
                      <span class="octobus__select is-medium">
                        <select v-model="reason" v-validate="'required'" name="refund__reason">
                          <option :value="0">{{ $t('tickets.refund.reasonTripCancellation') }}</option>
                          <option :value="1">{{ $t('tickets.refund.reasonTripDelay') }}</option>
                          <option :value="2">{{ $t('tickets.refund.reasonOther') }}</option>
                        </select>
                      </span>
                    </p>
                  </div>
                  <p v-show="errors.has('refund__reason')" class="octobus__help is-danger">{{ errors.first('refund__reason') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="octobus__columns" v-if="reason === 2">
          <div class="octobus__column">
            <div class="octobus__field">
              <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="refund__reason-details">
                {{ $t('tickets.refund.reasonDetails') }}
              </label>
              <textarea class="textarea" name="refund__reason-details" rows="4" v-model="other" v-validate="'required'"></textarea>
              <p v-show="errors.has('refund__reason-details')" class="octobus__help is-danger">{{ errors.first('refund__reason-details') }}</p>
            </div>
          </div>
        </div>
        <div class="octobus__columns">
          <div class="octobus__column">
            <p>{{ $t('tickets.refund.info1') }}</p>
            <p>{{ $t('tickets.refund.info2') }}</p>
          </div>
        </div>
      </section>
      <footer class="octobus__modal-card-foot">
        <button class="octobus__button is-primary" :class="{'is-loading': loading}" @click="onSubmit" :disabled="errors.any()">{{ $t('tickets.refund.successBtn') }}</button>
        <button class="octobus__button" @click="onHideModal">{{ $t('tickets.refund.cancelBtn') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faUser } from '@fortawesome/fontawesome-free-solid';
import api from '@/api';


export default {
  name: 'Refund',
  components: {
    FontAwesomeIcon,
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    refundData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      reason: null,
      other: '',
      error: {},
    };
  },
  methods: {
    onHideModal() {
      this.$emit('hideModal');
    },
    async onSubmit() {
      const refundValid = await this.$validator.validateAll();

      if (refundValid === true) {
        this.sendRefund();
      }
    },
    sendRefund() {
      this.loading = true;
      const refundRequest = {
        ...this.refundData,
        reason: this.reason,
        ...this.reason === 2 ? { other: this.other } : {},
      };

      api.Content.setrefundreq(refundRequest).then((res) => {
        if (res && res.error) {
          this.error = res.error;
        } else {
          this.$EventBus.$emit('refund:done');
          this.onHideModal();
        }
        this.loading = false;
      });
    },
  },
  computed: {
    userIcon() {
      return faUser;
    },
  },
};
</script>

<style lang="scss" scoped>
  .octobus__signin-error {
    font-size: 0.9rem;
  }

  .textarea {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/_common/Refund.vue